<template>
  <modal
    :heading="heading"
    modal-class="-confirm-remove"
    :show-footer="false"
    :handle-close-click="handleCloseClick"
  >
    <!-- eslint-disable vue/no-v-html -->
    <p v-if="subheading" class="light" v-html="subheading" />

    <div class="confirm-actions">
      <a
        v-if="handleConfirmClick"
        href="#"
        class="btn -main -block"
        @click.prevent.once="handleConfirmClick"
        >{{ buttonText }}</a
      >
      <a v-else :href="url" class="btn -main" @click="preventDoubleClick">{{ buttonText }}</a>
      <a href="" class="btn -link" @click.prevent="handleCloseClick">{{ cancelText }}</a>
    </div>
  </modal>
</template>

<script>
import modal from './modal.vue'
export default {
  name: 'ModalConfirm',
  components: { modal },
  /* eslint-disable vue/require-default-prop */
  props: {
    heading: String,
    subheading: String,
    buttonText: {
      default: 'Remove',
      type: String,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },

    // TODO: switch to emitter
    // either handleConfirmClick or url passed in as the action of the button
    handleConfirmClick: Function,
    url: String,
    handleCloseClick: Function,
  },
  methods: {
    // can't figure out how to setup @click.once on a link, so go with this
    preventDoubleClick(e: Event) {
      if (typeof this.clicked === 'undefined') {
        this.clicked = true
      } else {
        e.preventDefault()
      }
    },
  },
}
</script>
